import {Component, OnDestroy, OnInit} from '@angular/core';
import * as Validation from "../../../../../../shared/constants/validation.constants";
import {CommonService} from "../../../../../../shared/services/common.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../../../state/app.state";
import {FetchObQuestionsRequest, SaveAnswersRequest} from "../../../../../core/authentication.actions";
import {obQuestionList, saveAnswersInfo} from "../../../../../core/authentication.selectors";
import {Question} from "../../../../../../../models/question";
import {dropDownOption} from "../../../../../../shared/constants/common.constants";

@Component({
  selector: 'app-adult-info-form',
  templateUrl: './adult-info-form.component.html',
  styleUrls: ['./adult-info-form.component.css']
})
export class AdultInfoFormComponent implements OnInit, OnDestroy {

  private readonly onDestroy: Subject<any> = new Subject<any>();
  errorMessages: any = {};
  validation = Validation;
  saveAnswersLoading: boolean = false;
  obQuestionLoader: boolean = false;
  errorMessageMap = {
    'whatDoYouLikeToBeCalled_Other': {
      required: 'This field is required.',
      maxlength: 'Maximum 250 characters accepted'
    },
    'selfDescribe_Other': {
      required: 'This field is required.',
      maxlength: 'Maximum 250 characters accepted'
    },
    'preferredLaguage_Other': {
      required: 'This field is required.',
      maxlength: 'Maximum 250 characters accepted'
    },
    'medicalInsurance_Other': {
      required: 'This field is required.',
      maxlength: 'Maximum 250 characters accepted'
    },
  }

  questionList: Question[];

  pronounOthersSelected: boolean = false;
  selfDescriptionOthersSelected: boolean = false;
  preferredLanguageOthersSelected: boolean = false;
  insuranceOthersSelected: boolean = false;

  form = new FormGroup<any>({})

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
  ) {
    this.store.dispatch(FetchObQuestionsRequest({payload: {questionGroup: 'obPersonalDetails'}}));
  }

  ngOnInit() {
    this.store
      .select(obQuestionList)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.questionList = data.list;
        this.obQuestionLoader = data.loading;
        if (this.questionList.length) {
          this.questionList.forEach((question: any) => {
            this.errorMessageMap[`${question.key}`] = {
              required: 'This field is required.',
            }
            this.form.addControl(`${question.key}`, new FormControl({
              value: '',
              disabled: false
            }, [Validators.required]));
          })
          this.listenForValueChange();
        }
      });

    this.store
      .select(saveAnswersInfo)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.saveAnswersLoading = data.loading;
      })
  }

  continue() {
    // ERROR CHECK IN THE FORM//
    if (this.form.invalid) {
      this.checkForErrors();
      setTimeout(() => {
        $(".form-field.ng-invalid")[0].parentElement.scrollIntoView();
      }, 0);
      return;
      return;
    }

    // PAYLOAD CREATION//
    const formValues = this.form.getRawValue();

    // ACTION DISPATCH FOR CALLING API

    const payload = {
      responses: []
    };

    Object.keys(formValues).forEach(value => {
      const question = this.questionList.find((item: any)=>item.key === value);
      const questionId = question?.id;
      const dataType = question?.dataType;
      
      if (Array.isArray(formValues[value])) {
        payload.responses.push({
          questionId: Number(questionId),
          multiselectOptions: formValues[value]
        })
      } else {
        if (typeof (formValues[value]) === "string" || dataType == 3 || dataType == 4) {
          if (value.includes('_Other')) {
            const separatedValue = value.split('_')[0]
            const questionId = this.questionList.find((item: any)=>item.key === separatedValue)?.id
            payload.responses.forEach(e => {
              if (e.questionId === questionId) {
                e['otherValue'] = String(formValues[value])
              }
            })
          } else {
            payload.responses.push({
              questionId: Number(questionId),
              otherValue: String(formValues[value])
            });
          }
        } else {
          payload.responses.push({
            questionId: Number(questionId),
            selectedOptionKey: formValues[value]
          });
        }
      }
    })
    this.store.dispatch(SaveAnswersRequest({payload}));
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }


  listenForValueChange() {

    this.form.controls['whatDoYouLikeToBeCalled']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data === dropDownOption.others) {
          this.pronounOthersSelected = true
          this.form.addControl('whatDoYouLikeToBeCalled_Other', new FormControl({value: '', disabled: false}, [Validators.required ,  Validators.maxLength(this.validation.onboarding.other.length.max),]));
        } else {
          this.pronounOthersSelected = false
          this.form.removeControl('whatDoYouLikeToBeCalled_Other');
        }
      });

    this.form.controls['selfDescribe']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (Array.isArray(data)) {
          this.selfDescriptionOthersSelected = false
          this.form.removeControl('selfDescribe_Other');

          if (!data.includes(dropDownOption.preferNotToAnswer) && data.includes(dropDownOption.others)) {
            this.selfDescriptionOthersSelected = true
            this.form.addControl('selfDescribe_Other', new FormControl({value: '', disabled: false}, [Validators.required , Validators.maxLength(this.validation.onboarding.other.length.max),]));
          }
        }
      });

    this.form.controls['preferredLaguage']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data === dropDownOption.others) {
          this.preferredLanguageOthersSelected = true
          this.form.addControl('preferredLaguage_Other', new FormControl({value: '', disabled: false}, [Validators.required , Validators.maxLength(this.validation.onboarding.other.length.max),]));
        } else {
          this.preferredLanguageOthersSelected = false
          this.form.removeControl('preferredLaguage_Other');
        }
      });

    this.form.controls['medicalInsurance']?.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (Array.isArray(data)) {
          this.insuranceOthersSelected = false
          this.form.removeControl('medicalInsurance_Other');

          if (!data.includes(dropDownOption.preferNotToAnswer) && data.includes(dropDownOption.others)) {
            this.insuranceOthersSelected = true
            this.form.addControl('medicalInsurance_Other', new FormControl({value: '', disabled: false}, [Validators.required ,Validators.maxLength(this.validation.onboarding.other.length.max),]));
          }
        }
      });

  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
